// extracted by mini-css-extract-plugin
module.exports = {"submit":"submit_submit__0sq9a","submitError":"submit_submitError__HOjda"};